import { forwardRef } from 'react';
import { ExclamationCircleIcon, LockClosedIcon } from '@heroicons/react/24/outline';

import { classNames } from 'support/helpers/generic/generic';

export const ErrorIcon = forwardRef<HTMLDivElement, { className?: string }>(({ className }, ref) => {
  return (
    <div ref={ref}>
      <ExclamationCircleIcon className={classNames('shrink-0 size-5 text-red-700', className)} />
    </div>
  );
});

ErrorIcon.displayName = 'ErrorIcon';

export const LockerIcon = () => {
  return (
    <span className="-m-1 flex size-6 shrink-0 items-center justify-center rounded border border-gray-200 bg-white text-gray-400">
      <LockClosedIcon className="size-4 " />
    </span>
  );
};
